import type { VideoBlock } from '@atlas/renderer';
import type { VideoBlockSource } from '@atlas/renderer/video-block';
import isHtmlElementNode from '@atlas/tool/box/dom/isHtmlElementNode';

export default function extractVideoNodeSources(videoNode: HTMLVideoElement): VideoBlock['sources'] | null {
    const sources: VideoBlockSource[] = Array.from(videoNode.children)
        .filter((node): node is HTMLSourceElement => isHtmlElementNode(node, 'SOURCE') && !!node.src)
        .map((node) => ({ url: node.src, type: node.type || '' }));
    if (sources.length) return sources as VideoBlock['sources'];
    return null;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('extractVideoNodeSources', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
